"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = exports.missingRefs = exports.annotate = exports.getById = exports.getKey = exports.getMeta = exports.isDerefd = exports.isAnnotated = exports.isRef = exports.normalizeUri = exports.LII_RE = void 0;
const utils_1 = require("./utils");
const __meta = Symbol();
exports.LII_RE = /^[a-zA-Z][a-zA-Z0-9\.\-_:]*$/; // Location-independent identifier, JSON Schema draft 7, par. 8.2.3
function normalizeUri(input, scope) {
    const uri = new URL(input, scope);
    const out = uri.toString();
    return out + (!uri.hash && out[out.length - 1] !== '#' ? '#' : '');
}
exports.normalizeUri = normalizeUri;
function isRef(obj) {
    return obj !== null && typeof obj === 'object' && typeof obj.$ref === 'string';
}
exports.isRef = isRef;
function isAnnotated(obj) {
    return obj !== null && typeof obj === 'object' && typeof obj[__meta] === 'object';
}
exports.isAnnotated = isAnnotated;
function isDerefd(obj) {
    return isAnnotated(obj) && obj[__meta].derefd === true;
}
exports.isDerefd = isDerefd;
function getMeta(obj) {
    if (!isAnnotated(obj)) {
        throw new Error('Not annotated');
    }
    return obj[__meta];
}
exports.getMeta = getMeta;
function getKey(obj) {
    const parent = getMeta(obj).parent;
    if (typeof parent === 'undefined') {
        return undefined;
    }
    else if (Array.isArray(parent)) {
        for (let i = 0; i < parent.length; i++) {
            if (parent[i] === obj) {
                return i;
            }
        }
        return undefined;
    }
    else {
        return Object.keys(parent).find(k => parent[k] === obj);
    }
}
exports.getKey = getKey;
function getById(obj, id) {
    if (obj === null || typeof obj !== 'object') {
        throw new TypeError('Invalid object');
    }
    const meta = getMeta(obj);
    return meta.registry[normalizeUri(id, meta.scope)];
}
exports.getById = getById;
function annotate(obj, options) {
    if (obj === null || typeof obj !== 'object') {
        throw new TypeError('Invalid object');
    }
    else if (isAnnotated(obj)) {
        throw new Error('Already annotated');
    }
    obj[__meta] = {
        registry: options.registry || {},
        refs: options.refs || new Set(),
        root: obj
    };
    obj[__meta].registry[normalizeUri(options.scope)] = obj;
    return (function _annotate(obj, scope) {
        if (isRef(obj)) {
            const uri = new URL(obj.$ref, scope);
            uri.hash = '';
            getMeta(obj).refs.add(uri.toString() + '#');
            obj[__meta].scope = normalizeUri(scope);
        }
        else {
            if (typeof obj.$id === 'string') {
                if (!obj.$id || obj.$id === '#') {
                    throw new SyntaxError(`Invalid identifier ${obj.$id}`);
                }
                const id = new URL(obj.$id, scope);
                if (id.hash && !id.hash.substr(1).match(exports.LII_RE)) {
                    throw new SyntaxError(`Invalid identifier ${obj.$id}`);
                }
                obj[__meta].scope = normalizeUri(obj.$id, scope);
                obj[__meta].registry[obj[__meta].scope] = obj;
                obj[__meta].root = obj;
            }
            else {
                obj[__meta].scope = normalizeUri(scope);
            }
            const keys = Object.keys(obj);
            for (let key of keys) {
                const next = obj[key];
                if (next !== null && typeof next === 'object' && !isAnnotated(next)) {
                    const meta = getMeta(obj);
                    next[__meta] = {
                        registry: meta.registry,
                        refs: meta.refs,
                        parent: obj,
                        root: meta.root
                    };
                    _annotate(next, `${meta.scope}/${utils_1.escape(key)}`);
                }
            }
        }
        return obj;
    })(obj, options.scope);
}
exports.annotate = annotate;
function missingRefs(obj) {
    const meta = getMeta(obj);
    const known = new Set(Object.keys(meta.registry));
    return [...meta.refs].filter(r => !known.has(r));
}
exports.missingRefs = missingRefs;
function normalize(obj) {
    if (!isAnnotated(obj)) {
        throw new Error('Not annotated');
    }
    const meta = getMeta(obj);
    if (typeof obj.$id === 'string') {
        obj.$id = normalizeUri(obj.$id, meta.scope);
    }
    const keys = Object.keys(obj);
    for (let key of keys) {
        const o = obj[key];
        if (o !== null && typeof o === 'object') {
            if (isRef(o)) {
                o.$ref = normalizeUri(o.$ref, meta.scope);
            }
            else {
                normalize(o);
            }
        }
    }
    return obj;
}
exports.normalize = normalize;
//# sourceMappingURL=meta.js.map